// extracted by mini-css-extract-plugin
export default {"notification":"TPPNotification_notification__C-wyM","clientName":"TPPNotification_clientName__v93YE api-enabler-styles_bold__M2Htp"};